/**
 * Apply-loan mobile OTP — Fundswalla only (not dhanwalle).
 * Local: relative paths via setupProxy. Live: absolute fundswalla.in.
 */
const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_TASK_API_ORIGIN ||
  "https://fundswalla.in";

export const FUNDSWALLA_OTP_API_KEY =
  process.env.REACT_APP_FUNDSWALLA_OTP_API_KEY || "lkru^%&jND244ht5a";

const isDev = process.env.NODE_ENV === "development";

/** POST /Api/TaskApi/sendOtp1 */
export const sendOtp1Url = () =>
  isDev ? "/Api/TaskApi/sendOtp1" : `${API_ORIGIN}/Api/TaskApi/sendOtp1`;

/** POST /Api/TaskApi/verifyOtp1 */
export const verifyOtpPhpUrl = () =>
  isDev ? "/Api/TaskApi/verifyOtp1" : `${API_ORIGIN}/Api/TaskApi/verifyOtp1`;

export const fundswallaOtpHeaders = () => ({
  "Content-Type": "application/x-www-form-urlencoded",
  "X-API-KEY": FUNDSWALLA_OTP_API_KEY,
});
